import { createApp } from 'vue'
import { createPinia } from 'pinia'

import 'bootstrap/dist/css/bootstrap.rtl.min.css'
import 'remixicon/fonts/remixicon.css'
import '@/assets/scss/app.scss'

import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { useAuthStore } from '@/stores/auth'
import { useThemeStore } from '@/stores/theme'
import { setUnauthorizedHandler } from '@/services/http'

const app = createApp(App)

app.use(createPinia())

useThemeStore().init()

const auth = useAuthStore()
auth.restore()
// Refresh the local profile payload (cheap: the SSO access is cached on the
// profile, so this never calls the auth service).
if (auth.isAuthenticated) auth.fetchMe()

router.beforeEach((to) => {
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  if (to.meta.public && auth.isAuthenticated && to.name === 'login') {
    return { name: 'home' }
  }
  return true
})

setUnauthorizedHandler(() => {
  auth.clear()
  if (router.currentRoute.value.name !== 'login') {
    router.push({ name: 'login' })
  }
})

app.use(router)
app.use(i18n)
app.mount('#app')
